
export const tagsJson=[{
    key:1,
    color:'#eb2f96',
    bgcolor:'#fff0f6',
    bdcolor:'#ffadd2'
},{
    key:2,
    color:'#f5222d',
    bgcolor:'#fff1f0',
    bdcolor:'#ffa39e'
},{
    key:3,
    color:'#fa541c',
    bgcolor:'#fff2e8',
    bdcolor:'#ffbb96'
},{
    key:4,
    color:'#fa8c16',
    bgcolor:'#fff7e6',
    bdcolor:'#ffd591'
},{
    key:5,
    color:'#faad14',
    bgcolor:'#fffbe6',
    bdcolor:'#ffe58f'
},{
    key:6,
    color:'#a0d911',
    bgcolor:'#fcffe6',
    bdcolor:'#eaff8f'
},{
    key:7,
    color:'#52c41a',
    bgcolor:'#f6ffed',
    bdcolor:'#b7eb8f'
},{
    key:8,
    color:'#13c2c2',
    bgcolor:'#e6fffb',
    bdcolor:'#87e8de'
},{
    key:9,
    color:'#1890ff',
    bgcolor:'#e6f7ff',
    bdcolor:'#91d5ff'
},{
    key:10,
    color:'#2f54eb',
    bgcolor:'#f0f5ff',
    bdcolor:'#adc6ff'
},{
    key:11,
    color:'#722ed1',
    bgcolor:'#f9f0ff',
    bdcolor:'#d3adf7'
},{
    key:12,
    color:'#fff',
    bgcolor:'#ff5500',
    bdcolor:'#ff5500'
},{
    key:13,
    color:'#fff',
    bgcolor:'#2db7f5',
    bdcolor:'#2db7f5'
},{
    key:14,
    color:'#fff',
    bgcolor:'#87d068',
    bdcolor:'#87d068'
},{
    key:15,
    color:'#fff',
    bgcolor:'#108ee9',
    bdcolor:'#108ee9'
},{
    key:16,
    color:'#fff',
    bgcolor:'#13c2c2',
    bdcolor:'#13c2c2'
},{
    key:17,
    color:'#fff',
    bgcolor:'#722ed1',
    bdcolor:'#722ed1'
},{
    key:18,
    color:'#fff',
    bgcolor:'#eb2f96',
    bdcolor:'#eb2f96'
},]


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/modeTab/tagdata.tsx